import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AlumniContributionJson } from '../data/Alumni';

const Alumni = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const alumniEvent = AlumniContributionJson[0];

  return (
    <div className="relative bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black w-full py-16 overflow-hidden">
      
      {/* Decorative glowing blobs */}
      <div className="absolute -top-40 -left-40 w-96 h-96 bg-indigo-700/30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-purple-600/30 rounded-full blur-3xl animate-ping"></div>
      
      {/* Main Container */}
      <div 
        id="Alumni" 
        className="relative z-10 w-full md:w-9/12 mx-auto bg-white/90 backdrop-blur-xl shadow-2xl rounded-3xl p-10 border border-gray-300"
      >
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-6 
                       text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-purple-600 
                       drop-shadow-lg tracking-wide">
          {alumniEvent.title}
        </h2>

        {/* Message */}
        <p className="text-lg text-center mb-12 mx-auto max-w-3xl text-gray-700 leading-relaxed italic">
          {alumniEvent.thankingMessage}
        </p>

        {/* Alumni Card */}
        <div className="flex justify-center">
          <div
            data-aos="zoom-in"
            data-aos-duration="1000"
            className="bg-gradient-to-tr from-indigo-50 via-white to-indigo-100 w-full md:w-8/12 lg:w-5/12 
                       shadow-xl rounded-2xl overflow-hidden flex flex-col 
                       transition-transform transform hover:scale-105 hover:shadow-indigo-400/40 duration-500"
          >
            {/* Image */}
            <img
              src={alumniEvent.imgSrc}
              alt={alumniEvent.title}
              className="w-full h-64 object-cover rounded-t-2xl"
            />

            {/* Card Content */}
            <div className="flex-1 p-6 flex flex-col justify-between text-center">
              <h3 className="text-2xl font-bold mb-3 text-purple-600 uppercase tracking-widest">
                Thank You!
              </h3>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                We deeply appreciate your <span className="font-semibold text-indigo-700">support </span> 
                 and <span className="font-semibold text-purple-700">generosity</span> in helping our college grow stronger.  
                Your contribution inspires future generations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alumni;
